import React from 'react';

type AuthInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const AuthInput: React.FC<AuthInputProps> = props => <input {...props} style={{ ...inputStyle, ...props.style }} />;

const inputStyle: React.CSSProperties = {
    border: '1px solid #ddd',
    borderRadius: 8,
    padding: '10px 12px',
    fontFamily: "'DM Mono',monospace",
    fontSize: 14,
    color: '#333',
    background: '#fafaf8',
    outline: 'none',
    width: '100%',
};

export default AuthInput;
